import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMouseRightDark = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 4.498 7.408",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		clipRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M4.348 2.76v-.473a2.1 2.1 0 0 0-2.1-2.1V2.76z"
		}), /* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeMiterlimit: 1.5,
			strokeWidth: .212,
			d: "M4.348 2.287a2.1 2.1 0 0 0-4.198 0v2.834a2.1 2.1 0 0 0 4.198 0zM4.348 2.76H.15M2.249 2.76V.188"
		})]
	})
});
export default SvgIconMouseRightDark;
